import { render, staticRenderFns } from "./MasterDataServiceDetail.vue?vue&type=template&id=6e2c31c8"
import script from "./MasterDataServiceDetail.vue?vue&type=script&lang=js"
export * from "./MasterDataServiceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports